import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet as ReactHelmet } from 'react-helmet-async';
export var Helmet = function (_a) {
    var title = _a.title, description = _a.description;
    return (_jsxs(ReactHelmet, { children: [_jsx("html", { lang: "en" }), _jsx("title", { children: title }), _jsx("meta", { name: "description", content: description })] }));
};
